// extracted by mini-css-extract-plugin
export default {"indent":"PI_indent__10aPY"};